import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NavigationItem } from '@models/navigation-item.interface';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, FontAwesomeModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  collapsed = input(false);
  mobileOpen = input(false);
  items = input.required<NavigationItem[]>();
  userInitial = input('U');
  userName = input('Usuario');
  userRole = input('Administrador');

  navClick = output<void>();
  collapseToggle = output<void>();
  logoutClick = output<void>();

  readonly userMenuOpen = signal(false);

  toggleUserMenu(): void {
    if (this.collapsed()) {
      this.logoutClick.emit();
      return;
    }

    this.userMenuOpen.update((open) => !open);
  }

  onLogout(): void {
    this.userMenuOpen.set(false);
    this.logoutClick.emit();
  }
}
